/* eslint-disable react/no-array-index-key,react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ANCHOR from 'common/consts/anchor';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import HREFS from 'common/consts/hrefs';
import { BLOG_LANGUAGES } from 'common/consts/languages';
import Logo from '../Logo/index';
import MainNavigationBar from './MainNavigationBar';
import Buttons from '../Buttons/index';
import StyledLink from './StyledLink';
import StyledBlogLink from './StyledBlogLink';
import Languages from '../Languages';
import StyledExternalLink from './StyledExternalLink';


@inject('coreStore', 'navigationStore', 'windowStore', 'appStore')
@observer
class MainNavigation extends Component {
  render() {
    const {
      renderLogo,
      renderButtons,
      paddingRight,
      paddingLeft,
      itemClick,
      coreStore: { translations },
      navigationStore: { buttonsSectionWidth },
      windowStore: { isOnTablet },
      appStore: { currentLanguage },
    } = this.props;

    let paddingLeftWithLogo = paddingLeft;
    let paddingRightWithButtons = paddingRight;

    if (renderLogo) {
      paddingLeftWithLogo = `calc(${paddingLeft} + 200px)`;
    }

    if (renderButtons) {
      paddingRightWithButtons = `calc(${paddingRight} + ${24 + buttonsSectionWidth}px)`;
    }

    const blogLanguagesArray = Object.entries(BLOG_LANGUAGES).map(([key, value]) => value.value);

    return (
      <React.Fragment>
        {renderLogo ? <Logo fixed /> : ''}
        <MainNavigationBar
          paddingLeft={paddingLeftWithLogo}
          paddingRight={paddingRightWithButtons}
        >
          <StyledLink
            to={ANCHOR.HOME[currentLanguage]}
            onClick={() => itemClick()}
            exact
          >
            {translations.NAVIGATION_ZONIFERO_PRODUCTS}
          </StyledLink>
          {blogLanguagesArray.includes(currentLanguage) && (
            <StyledBlogLink
              to={ANCHOR.BLOG[currentLanguage]}
              onClick={() => itemClick()}
            >
              {translations.NAVIGATION_BLOG}
            </StyledBlogLink>
          )}
          <StyledLink
            to={ANCHOR.FAQ[currentLanguage]}
            onClick={() => itemClick()}
          >
            {translations.NAVIGATION_FAQ}
          </StyledLink>
          {currentLanguage === 'pl' && (
            <StyledLink
              to={ANCHOR.FOR_INVESTORS[currentLanguage]}
              onClick={() => itemClick()}
            >
              Dla inwestorów
            </StyledLink>
          )}
          <StyledExternalLink href={currentLanguage === 'pl' ? 'https://zonifero.com/pl/support' : 'https://lp.zonifero.com/workplaces-handbook'}>
            {translations.NAVIGATION_PROPTECH}
          </StyledExternalLink>
          {/* <StyledExternalLink href="/reshaping-modern-office-new-normal">
            Proptech Handbook 2
          </StyledExternalLink> */}
          {currentLanguage === 'pl' && (
            <StyledLink
              to={ANCHOR.WORK[currentLanguage]}
              onClick={() => itemClick()}
            >
              {translations.NAVIGATION_WORK}
            </StyledLink>
          )}
          {!isOnTablet && (
            <React.Fragment>
              <Languages />
              <StyledExternalLink
                href={HREFS.SIGN_IN}
                onClick={() => itemClick()}
                bold
              >
                {translations.NAVIGATION_SIGN_IN}
              </StyledExternalLink>
            </React.Fragment>
          )}
        </MainNavigationBar>
        {renderButtons ? <Buttons /> : ''}
      </React.Fragment>
    );
  }
}

MainNavigation.propTypes = {
  itemClick: PropTypes.func,
  renderLogo: PropTypes.bool,
  renderButtons: PropTypes.bool,
  paddingRight: PropTypes.string,
  paddingLeft: PropTypes.string,
};
MainNavigation.defaultProps = {
  itemClick: () => { },
  renderLogo: true,
  renderButtons: true,
  paddingRight: '0px',
  paddingLeft: '0px',
};

export default withRouter(MainNavigation);



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MainNavigation/index.jsx